export type OptionEqualityFn = (opt1: any, opt2: any) => boolean;

export const Attributes = {
  Listbox: 'data-pl-combobox-role="menu"',
  Input: 'data-pl-combobox-role="input"',
  Dropdown: 'data-pl-combobox-role="dropdown"',
  Toggler: 'data-pl-combobox-role="toggle"',
  Option: 'data-pl-combobox-option',
};

export const OptionClasses = {
  Option: 'pl-select-menu__item',
  IsActive: 'is-hovered',
  ShownClass: 'is-dropdown-shown',
  IsSelected: 'is-selected',
  IsDisabled: 'is-disabled',
  EmptyMessage: 'pl-select-menu__empty-message',
};
